import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

export type PillTone = 'accent' | 'neutral';

interface PillProps {
  children: ReactNode;
  tone?: PillTone;
  height?: number;
}

/** Badge rotunjit: accentuat (fundal accent-soft) sau neutru (fundal de pagină). */
export function Pill({ children, tone = 'neutral', height = 28 }: PillProps) {
  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        flex: 'none',
        height,
        px: '12px',
        borderRadius: `${theme.radii.pill}px`,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        backgroundColor:
          tone === 'accent' ? theme.palette.weather.accentSoft : theme.palette.weather.bg,
        color: tone === 'accent' ? theme.palette.weather.accent : theme.palette.weather.soft,
        transition: 'background-color .5s ease, color .5s ease',
      })}
    >
      {children}
    </Box>
  );
}
